export const PATH_CAMPAIGNS = "/campaigns";
export const PATH_CAMPAIGNS_UID = `${PATH_CAMPAIGNS}/:uid`;
